import { DefaultContainer } from '@/components/DefaultContainer';
import { DeleteDataResult } from '@/generated';
import { maintenanceApi } from '@/generated/clients';
import { Box, Button, Stack, Switch, TextField, Typography } from '@mui/material';
import { useState } from 'react';

export const Maintenance = () => {
  const [disableDryRun, setDisableDryRun] = useState(false);
  const [cleanUpResult, setCleanUpResult] = useState<DeleteDataResult>({ deleteCount: 0, dryRun: true });
  const [emailSubject, setEmailSubject] = useState<string>();
  const [emailContent, setEmailContent] = useState<string>();

  return (
    <DefaultContainer>
      <Box sx={{ m: 2 }}>
        <Stack gap={4} direction={'row'}>
          <Box>
            Disable Dry Run <Switch checked={disableDryRun} onChange={() => setDisableDryRun(!disableDryRun)} />
          </Box>
          <Box>
            <Button variant="outlined" onClick={async () => setCleanUpResult(await maintenanceApi.maintenanceDeleteUnusedFiles({ deleteData: { dryRun: !disableDryRun } }))}>
              Clean Up Files
            </Button>
          </Box>
          <Box>
            <Button variant="outlined" onClick={async () => setCleanUpResult(await maintenanceApi.maintenanceDeleteUnusedMetadata({ deleteData: { dryRun: !disableDryRun } }))}>
              Clean Up Metadata
            </Button>
          </Box>
          <Box>
            Clean Up Result: {cleanUpResult.deleteCount} Deleted - Dry run {cleanUpResult.dryRun}
          </Box>
        </Stack>
        <Stack>
          <Typography>Send Email to All Users:</Typography>
          <Stack sx={{ mt: 2, gap: 2, alignItems: 'flex-start' }}>
            <Typography>Subject:</Typography>
            <TextField value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} sx={{ width: 500 }} />

            <Typography>Content:</Typography>
            <Stack sx={{ gap: 5 }} direction={'row'}>
              <TextField value={emailContent} onChange={(e) => setEmailContent(e.target.value)} sx={{ width: 500 }} multiline minRows={8}>
                {emailContent}
              </TextField>
              <Stack gap={1}>
                <Typography>Content Preview:</Typography>
                {emailContent ? <Box dangerouslySetInnerHTML={{ __html: emailContent }} /> : <></>}
              </Stack>
            </Stack>
            <Button
              onClick={async () => {
                if (emailContent && emailSubject) {
                  await maintenanceApi.maintenanceSendEmailToAllUsers({ emailContainer: { subject: emailSubject, content: emailContent } });
                  setEmailContent('');
                  setEmailSubject('');
                  alert('Email sent!');
                }
              }}
              variant="outlined"
            >
              Send
            </Button>
          </Stack>
        </Stack>
      </Box>
    </DefaultContainer>
  );
};
